import {
  CASE_ADD_REQUEST,
  CASE_ADD_SUCCESS,
  CASE_ADD_FAILURE,
  CASE_GET_BY_USER_REQUEST,
  CASE_GET_BY_USER_SUCCESS,
  CASE_GET_BY_USER_FAILURE,
  SET_CURRENT_CASE_ID,
  CASE_GET_BY_CASE_ID_REQUEST,
  CASE_GET_BY_CASE_ID_SUCCESS,
  CASE_GET_BY_CASE_ID_FAILURE,
  RESET_CASE_STATE,
  RESET_CASE_STATUS,
  FB_CASE_USER_GET_NEW_PARTICIPANT_REQUEST,
  FB_CASE_USER_GET_NEW_PARTICIPANT_SUCCESS,
  FB_CASE_USER_GET_NEW_PARTICIPANT_FAILURE,
  FB_REMOVE_PARTICIPANT,
  CASE_LEAVE_SUCCESS,
  CASE_LEAVE_FAILURE,
  CASE_LEAVE_REQUEST,
  FB_CASE_LEAVE,
  FB_CASE_GET_HEADER_INFO_SUCCESS,
  FB_CASE_GET_HEADER_INFO_FAILURE,
  FB_CASE_GET_HEADER_INFO_REQUEST,
  CASE_UPDATE_SUCCESS,
  CASE_UPDATE_FAILURE,
  CASE_UPDATE_REQUEST,
  CASE_INFO,
  CASE_CANCEL_AIRFORCE_READINESS_REQUEST,
  CASE_CANCEL_AIRFORCE_READINESS_SUCCESS,
  CASE_CANCEL_AIRFORCE_READINESS_FAILURE,
  CASE_PARTICIPANT_EDIT_REQUEST,
  CASE_PARTICIPANT_EDIT_SUCCESS,
  CASE_PARTICIPANT_EDIT_FAILURE,
  CASE_SEARCH_REQUEST,
  CASE_SEARCH_SUCCESS,
  CASE_SEARCH_FAILURE,
  // CASE_SCHEDULE_APPT,
} from '../../actions/actionTypes';
import { CASE_AVATAR } from '../../constants/objectTypes';
import {
  addCase as addCaseService,
  getAllCases as getAllCasesService,
  getMyCase as getMyCaseService,
  getCase as getCaseService,
  getCaseHeaderInfo,
  getParticipantByUser,
  removeParticipant,
  updateCase as updateCaseService,
  updateCaseParticipant as updateCaseParticipantService,
  findCases as findCasesService,
} from '../../services/caseService';

import { cancelReadiness as cancelReadinessService } from '../../services/calendarService';
import { updatePatient as updatePatientService } from '../../services/patientService';
import { updateEmployerUser as updateEmployerUserService } from '../../services/employerService';

import { getPatientByCaseId } from '../../reducers/entities_patients';
import { markNotificationAsRead } from '../notifications/actions';
import { removeFileEntryFromReduxAndFirebase } from '../components/actions';

import { getCurrentEmployer } from '../../selectors/entities';

export function searchCases(employerId, query) {
  return function (dispatch, getState) {
    dispatch({
      types: [CASE_SEARCH_REQUEST, CASE_SEARCH_SUCCESS, CASE_SEARCH_FAILURE],
      promise: findCasesService(employerId, query, { normalizeResult: true }),
    });
  };
}

export function addCase(caseObj, employerId = null) {
  // required on the server
  caseObj.champion = false;

  return function (dispatch, getState) {
    dispatch({
      types: [CASE_ADD_REQUEST, CASE_ADD_SUCCESS, CASE_ADD_FAILURE],
      promise: addCaseService(caseObj, employerId),
    });
  };
}

export function resetState(payload) {
  return function (dispatch) {
    dispatch({ type: RESET_CASE_STATE, payload });
  };
}

export function resetStatusState() {
  return function (dispatch) {
    dispatch({ type: RESET_CASE_STATUS });
  };
}

export function updateParticipant(caseId, participantObj) {
  return {
    types: [
      CASE_PARTICIPANT_EDIT_REQUEST,
      CASE_PARTICIPANT_EDIT_SUCCESS,
      CASE_PARTICIPANT_EDIT_FAILURE,
    ],
    promise: updateCaseParticipantService(caseId, participantObj),
  };
}

async function _getCasesEmployer(dispatch, getState, employer) {
  const currentCaseId = getState().application.currentCaseId;
  if (currentCaseId && !isNaN(currentCaseId)) {
    dispatch(getCaseAndAddItToRedux(currentCaseId));
  }
  return dispatch(getMyCase());
}

export function getAllCasesAndEvents() {
  return async function (dispatch, getState) {
    // return Promise.resolve();
    const employer = getCurrentEmployer(getState());

    try {
      dispatch({ type: CASE_GET_BY_USER_REQUEST });
      let result = { entities: {} };
      if (!employer) {
        result = await getAllCasesService();
      } else {
        await _getCasesEmployer(dispatch, getState, employer);
      }
      dispatch({ type: CASE_GET_BY_USER_SUCCESS, payload: result });
      // make sure current case id is set to a case thats in entities.cases
      dispatch(setCurrentCaseId(result));
    } catch (e) {
      dispatch({
        type: CASE_GET_BY_USER_FAILURE,
        payload: { message: e.message, response: e.response },
      });
      console.error('getAllCasesAndEvents error', e);
      return Promise.reject(e);
    }
  };
}

function _updateApplicationStateForCase({
  currentCaseId,
  currentTopicId,
  currentEventId,
  shouldScrollToDate,
  getState,
  dispatch,
}) {
  if (currentCaseId) currentCaseId = parseInt(currentCaseId);
  if (currentTopicId) currentTopicId = parseInt(currentTopicId);
  if (currentEventId) currentEventId = parseInt(currentEventId);

  let topics = getState().entities.topics;
  // we might not have topics yet, if so just set currentTopicId so its set when topics are pulled
  if (!currentTopicId || topics[currentTopicId]?.caseId !== currentCaseId) {
    if (Object.keys(topics).length) {
      let topicsByCase = Object.keys(topics)
        .filter((key) => topics[key].caseId === currentCaseId)
        .map((key) => topics[key]);
      if (topicsByCase?.length) {
        currentTopicId = topicsByCase[0].topicId;
      }
    }
  }
  return dispatch({
    type: SET_CURRENT_CASE_ID,
    payload: {
      currentCaseId,
      currentTopicId,
      currentEventId,
      shouldScrollToDate,
    },
  });
}

export function setCurrentCaseId(normalizedResult) {
  return function (dispatch, getState) {
    let caseId = null;
    let cases = normalizedResult?.entities?.cases || getState().entities.cases || {};
    const currentCaseId = getState().application.currentCaseId;
    if (currentCaseId && cases[currentCaseId]) {
      caseId = currentCaseId;
    } else {
      caseId = cases[Object.keys(cases)[0]]?.caseId || null;
    }
    let currentTopicId = getState().application.currentTopicId || null;
    _updateApplicationStateForCase({
      currentCaseId: caseId,
      currentTopicId,
      getState,
      dispatch,
    });
  };
}

/**
 * After invitation is accepted this action is called to get the case info and add the listeners.
 * @param caseId
 * @returns {{types: [null,null,null], promise: *}}
 */
export function getCaseAndAddItToRedux(caseId, throwError = false) {
  return function (dispatch, getState) {
    return dispatch({
      types: [
        CASE_GET_BY_CASE_ID_REQUEST,
        CASE_GET_BY_CASE_ID_SUCCESS,
        CASE_GET_BY_CASE_ID_FAILURE,
      ],
      promise: getCaseService(caseId),
      throwError,
    });
  };
}

function getMyCase() {
  return function (dispatch, getState) {
    return dispatch({
      types: [
        CASE_GET_BY_CASE_ID_REQUEST,
        CASE_GET_BY_CASE_ID_SUCCESS,
        CASE_GET_BY_CASE_ID_FAILURE,
      ],
      promise: getMyCaseService(),
      throwError: true,
    });
  };
}

// options can include currentEventId, currentTopicId
export function changeCurrentCase(currentCaseId, options) {
  return async function (dispatch, getState) {
    currentCaseId = currentCaseId && !isNaN(currentCaseId) ? parseInt(currentCaseId) : null;
    if (currentCaseId) {
      const c = getState()?.entities?.cases?.[currentCaseId];
      if (!c?.participants) {
        await dispatch(getCaseAndAddItToRedux(currentCaseId));
      }
    }
    return _updateApplicationStateForCase(
      Object.assign({ currentCaseId, getState, dispatch }, options || {})
    );
  };
}

/**
 * TODO: when redux model is refactored move this to auth
 * @param item
 * @param caseId
 * @returns {{types: [null,null,null], promise: *}}
 */
export function getUserInfoForParticipant(userId, caseId) {
  return function (dispatch, getState) {
    dispatch({ type: FB_CASE_USER_GET_NEW_PARTICIPANT_REQUEST });
    return getParticipantByUser(userId, caseId)
      .then((result) => {
        //Check that the response is not empty (inactive user/ some inconsistent data)
        if (result && result.userId) {
          dispatch({
            type: FB_CASE_USER_GET_NEW_PARTICIPANT_SUCCESS,
            payload: result,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: FB_CASE_USER_GET_NEW_PARTICIPANT_FAILURE,
          payload: err,
        });
      });
  };
}

export function leaveCase(caseId) {
  return function (dispatch, getState) {
    dispatch({
      types: [CASE_LEAVE_REQUEST, CASE_LEAVE_SUCCESS, CASE_LEAVE_FAILURE],
      promise: removeParticipant(caseId).then((response) => {
        return {
          userId: getState().user.userId,
          caseId: caseId,
        };
      }),
    });
  };
}

export function removeParticipantLocally(userId, caseId) {
  return function (dispatch, getState) {
    // If we removed already don't do anything
    if (
      getState().entities.cases[caseId] &&
      getState().entities.cases[caseId].participants &&
      getState().entities.cases[caseId].participants[userId]
    ) {
      const payload = {
        userId: userId,
        caseId: caseId,
      };
      dispatch({ type: FB_REMOVE_PARTICIPANT, payload: payload });
    }
  };
}

export function removeUserFromCaseAfterServerRemovedIt(caseId) {
  return function (dispatch, getState) {
    //console.log('removeUserFromCaseAfterServerRemovedIt', getState().entities.events, Object.keys(getState().entities.cases));
    //1) Switch cases first so we don't have any errors or weird behaviour while removing the case.
    const remainingCaseIds = Object.keys(getState().entities.cases).filter((id) => id !== caseId);
    if (remainingCaseIds.length > 0) dispatch(changeCurrentCase(remainingCaseIds[0]));
    else dispatch(changeCurrentCase(null));
    //3) Remove notifications. We can't do this directly on redux becuase we need to set the notifications as read
    const notificationsToBeRemoved = Object.keys(getState().entities.notifications.notifications)
      .map((id) => getState().entities.notifications.notifications[id])
      .filter((n) => n.payload?.data?.caseId === caseId.toString());
    //TODO: Change endpoint to receive multiple ids.
    notificationsToBeRemoved.forEach((n) => dispatch(markNotificationAsRead(n.notificationId)));
    //4) Remove entities from redux
    dispatch({
      type: FB_CASE_LEAVE,
      payload: caseId,
    });
    dispatch(removeFileEntryFromReduxAndFirebase(CASE_AVATAR, caseId));
  };
}

export function openCaseInfo(caseId) {
  return function (dispatch, getState) {
    if (!caseId || isNaN(caseId)) {
      // so we can tell if its undefined or the string "undefined"
      let msg = !caseId
        ? `openCaseInfo called with falsy caseId ${caseId}`
        : `openCaseInfo called with truthy caseId ${caseId}`;
      console.error(msg);
      return;
    }
    dispatch({ type: CASE_INFO, payload: caseId });
    const c = getState().entities.cases?.[caseId];
    if (!c?.participants) {
      dispatch(getCaseAndAddItToRedux(caseId));
    } else {
      dispatch(getPatientByCaseId({ caseId }));
    }
  };
}

export function caseInfoChanged(caseId) {
  return function (dispatch, getState) {
    dispatch({
      types: [
        FB_CASE_GET_HEADER_INFO_REQUEST,
        FB_CASE_GET_HEADER_INFO_SUCCESS,
        FB_CASE_GET_HEADER_INFO_FAILURE,
      ],
      promise: getCaseHeaderInfo(caseId).then((response) => {
        // Check if we added a patient.
        if (!getState().entities.cases?.[caseId]?.patientId && response.patientId)
          dispatch(getPatientByCaseId({ caseId }));
        return response;
      }),
    });
  };
}

export function updateCase(caseId, caseObj) {
  return function (dispatch, getState) {
    dispatch({
      types: [CASE_UPDATE_REQUEST, CASE_UPDATE_SUCCESS, CASE_UPDATE_FAILURE],
      promise: updateCaseService(caseId, caseObj),
    });
  };
}

export function updateCaseEmployer(caseId, { caseObj, patientObj, employerUserObj }) {
  return function (dispatch, getState) {
    const proms = [];
    if (caseObj) {
      proms.push(updateCaseService(caseId, caseObj));
    }
    if (patientObj) {
      proms.push(updatePatientService(caseId, patientObj));
    }
    if (employerUserObj) {
      proms.push(
        updateEmployerUserService(employerUserObj.employerId, employerUserObj.userId, {
          clinical_location: employerUserObj.clinicalLocation,
          medical_service: employerUserObj.medicalService,
        })
      );
    }
    dispatch({
      types: [CASE_UPDATE_REQUEST, CASE_UPDATE_SUCCESS, CASE_UPDATE_FAILURE],
      promise: Promise.all(proms),
    });
  };
}

export function updateCaseParticipant(caseId, caseObj) {
  return function (dispatch) {
    dispatch({
      types: [CASE_UPDATE_REQUEST, CASE_UPDATE_SUCCESS, CASE_UPDATE_FAILURE],
      promise: updateCaseService(caseId, caseObj),
    });
  };
}

export function cancelReadiness(caseId, employerId, reason) {
  return {
    types: [
      CASE_CANCEL_AIRFORCE_READINESS_REQUEST,
      CASE_CANCEL_AIRFORCE_READINESS_SUCCESS,
      CASE_CANCEL_AIRFORCE_READINESS_FAILURE,
    ],
    promise: cancelReadinessService(caseId, employerId, reason),
  };
}
